import React from 'react';
import axios from 'axios';
import {Route, Switch, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import UserStoryList from "./UserStoriesList";
import UserStoryForm from "./UserStoryForm";
import UserStoryPreview from "./UserStoryPreview";
import * as NotificationsActionCreators from "../../redux/actions/notificationsActions";

import './style.css';

class UserStories extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      size: {
        width: 200,
        height: 200
      }
    };

    this.handleEditUserStory = this.handleEditUserStory.bind(this);
    this.handleChangeEnabled = this.handleChangeEnabled.bind(this);
    this.handleChangePending = this.handleChangePending.bind(this);
    this.handleRemoveUserStory = this.handleRemoveUserStory.bind(this);
  }

  handleChangeEnabled(userStory){
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    
    const enabled = !userStory.enabled;

    if (enabled && (!userStory.administratorName || !userStory.administratorText || userStory.administratorName.trim() === "" || userStory.administratorText.trim() === "")) {
      this.props.addNotification('warning', null, 'Téma ' + userStory.userStoryName + ' nebylo povoleno z důvodu nevyplnění administrátorských textů!');
    } else {
      axios.put(this.props.api.userStories + "/" + userStory._id, {
        enabled
      }, config).then((response) => {
        if (!userStory.enabled) {
          this.props.addNotification('success', response.status, 'Téma ' + userStory.userStoryName + ' bylo povoleno.');
        } else {
          this.props.addNotification('success', response.status, 'Téma ' + userStory.userStoryName + ' bylo zakázáno.');
        }
      }).catch((error) => {
        this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Téma se nepodařilo '+(enabled ? 'povolit' :  'zakázat')+'!');
        console.log("Axios error: ", error);
      })
    }
  }

  handleChangePending(userStory){
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };

    const pending = !userStory.pending;

    axios.put(this.props.api.userStories + "/" + userStory._id, {
      pending
    }, config).then((response) => {
      if (!userStory.pending) {
        this.props.addNotification('success', response.status, 'Téma ' + userStory.userStoryName + ' bylo odloženo.');
      } else {
        this.props.addNotification('success', response.status, 'Téma ' + userStory.userStoryName + ' bylo zaktivováno.');
      }
    }).catch((error) => {
      this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Téma se nepodařilo '+(pending ? 'odložit' :  'zaktivovat')+'!');
      console.log("Axios error: ", error);
    })
  }

  handleEditUserStory(userStoryId, values) {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    axios.put(this.props.api.userStories + "/" + userStoryId, {
      ...values,
    }, config).then((response) => {
      this.props.addNotification('success', response.status, 'Téma ' + response.data.userStoryName + ' bylo upraveno.');
      this.props.history.push('/userStories');
    }).catch((error) => {
      this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Téma se nepodařilo upravit!');
      this.props.history.push('/userStories');
      console.log("Axios error: ", error);
    });
  }

  handleRemoveUserStory(userStory) {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    axios.delete(this.props.api.userStories + "/" + userStory._id, config).then((response) => {
      this.props.addNotification('success', response.status, 'Téma ' + userStory.userStoryName + ' bylo odstraněno.');
    }).catch((error) => {
      this.props.addNotification('error', error.response.status, error.response.data.message ? error.response.data.message : 'Téma se nepodařilo odstranit!');
      console.log("Axios error: ", error);
    });
  }

  render() {
    return (
      <div id="page-userStories" className="right-col" role="main">
        <div className="page-title">
          <div className="title-left">
            <h3>Témata soutěžících</h3>
          </div>
        </div>
        <Switch>
          <Route exact path="/userStories" component={() =>
            <UserStoryList
              {...this.props}
              handleChangeEnabled={this.handleChangeEnabled}
              handleChangePending={this.handleChangePending}
              handleRemoveUserStory={this.handleRemoveUserStory}
            />
          }
          />
          <Route path="/userStories/preview/:id" component={() =>
            <UserStoryPreview
              {...this.props}
            />
          }
          />
          <Route path="/userStories/edit/:id" component={() =>
            <UserStoryForm
              {...this.props}
              title="Úprava tématu"
              button="Upravit"
              action={this.handleEditUserStory}
            />
          }
          />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = function(state){
  return {
    notifications: state.notifications,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    addNotification: (type, status, message) => dispatch(NotificationsActionCreators.addNotification(type, status, message)),
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserStories));



/** WEBPACK FOOTER **
 ** ./src/containers/UserStories/index.js
 **/